import { differenceInCalendarDays } from 'date-fns'

// The values of Rusty's `LengthOfStayBucket` GraphQL enum (potential_bookings.length_of_stay_bucket). They match
// because that enum keeps async-graphql's default SCREAMING_SNAKE names; Rusty's other enums use PascalCase, and
// renaming this one would make every bucket filter fail.
export enum LengthOfStayBucket {
  INDEFINITE = 'INDEFINITE',
  LTR = 'LTR',
  MTR = 'MTR',
  STR = 'STR',
  UNKNOWN = 'UNKNOWN',
}

export const lengthOfStayBucketOptions: { label: string; value: LengthOfStayBucket }[] = [
  { label: 'STR (7 nights or fewer)', value: LengthOfStayBucket.STR },
  { label: 'MTR (8–30 nights)', value: LengthOfStayBucket.MTR },
  { label: 'LTR (31+ nights)', value: LengthOfStayBucket.LTR },
  { label: 'Indefinite (no move out)', value: LengthOfStayBucket.INDEFINITE },
  { label: 'Unknown (missing or invalid dates)', value: LengthOfStayBucket.UNKNOWN },
]

export const lengthOfStayBucketLabel = (bucket: LengthOfStayBucket) =>
  lengthOfStayBucketOptions.find((option) => option.value === bucket)?.label || bucket

// Same rules as Rusty's `potential_booking_length_of_stay_bucket` (migration V341). Worked out here from the dates
// the Potential Booking page already has, so the page doesn't depend on the backend having the field.
export const getLengthOfStayBucket = (moveIn?: Date, moveOut?: Date): LengthOfStayBucket => {
  if (!moveIn) return LengthOfStayBucket.UNKNOWN
  if (!moveOut) return LengthOfStayBucket.INDEFINITE

  const nights = differenceInCalendarDays(moveOut, moveIn)
  if (nights <= 0) return LengthOfStayBucket.UNKNOWN
  if (nights <= 7) return LengthOfStayBucket.STR
  if (nights <= 30) return LengthOfStayBucket.MTR
  return LengthOfStayBucket.LTR
}

// The `potentialBookings` filter argument. Left out entirely when no bucket is picked: a backend without the
// argument rejects the whole query if the key is present, even as null.
export const lengthOfStayBucketsFilter = (bucket: LengthOfStayBucket | null | undefined) =>
  bucket ? { lengthOfStayBuckets: [bucket] } : {}

// A backend without the argument answers `unknown field "lengthOfStayBuckets"` and fails the whole list query.
export const isUnsupportedLengthOfStayFilterError = (error: unknown) =>
  error instanceof Error && error.message.includes('lengthOfStayBuckets')
